import React from "react";

const Menu = props => (
  <svg viewBox="0 0 19 15" fill="none" {...props}>
    <path
      d="M.583 1.25C.583.586 1.13 0 1.833 0h15c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-15c-.703 0-1.25-.547-1.25-1.25zm0 6.25c0-.664.547-1.25 1.25-1.25h15c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-15c-.703 0-1.25-.547-1.25-1.25zm17.5 6.25c0 .703-.586 1.25-1.25 1.25h-15c-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25h15c.664 0 1.25.586 1.25 1.25z"
      fill="currentColor"
    />
  </svg>
);

export default Menu;
